/** Locale-specific Terms & Conditions of Service URLs (OM-340 CR). */
export const SERVICE_GUARANTEES_TERMS_URLS = {
  en: 'https://www.purolator.com/en/terms-and-conditions-service',
  fr: 'https://www.purolator.com/fr/modalites-et-conditions-de-service',
} as const;
